import { useContent } from "../../context/ContentContext";
import { resolveUrl } from "../../lib/media";

const isVideo = (u) => u && /\.(mp4|webm|mov|m4v|ogv)$/i.test(u);

// Renders a custom background layer for a homepage section (color / gradient /
// image / video) with an optional dimming overlay. Sits BEHIND the section content
// (which must be relative z-10). Returns null when no custom background is set.
export const SectionBg = ({ id }) => {
  const { content } = useContent();
  const cfg = (content.sectionBackgrounds || {})[id];
  if (!cfg || !cfg.type || cfg.type === "none") return null;
  const dim = Math.min(100, Math.max(0, Number(cfg.dim ?? 55))) / 100;

  let layer = null;
  if (cfg.type === "color") {
    layer = <div className="absolute inset-0" style={{ background: cfg.color || "#050505" }} />;
  } else if (cfg.type === "gradient") {
    const from = cfg.from || "#0b1220";
    const to = cfg.to || "#050505";
    const angle = cfg.angle ?? 160;
    layer = <div className="absolute inset-0" style={{ background: `linear-gradient(${angle}deg, ${from}, ${to})` }} />;
  } else if (cfg.type === "image" && cfg.image) {
    layer = <img src={resolveUrl(cfg.image)} alt="" className="absolute inset-0 w-full h-full object-cover" />;
  } else if (cfg.type === "video" && (isVideo(cfg.video) || cfg.video)) {
    layer = <video src={resolveUrl(cfg.video)} className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline />;
  }
  if (!layer) return null;

  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-testid={`section-bg-${id}`} aria-hidden>
      {layer}
      {dim > 0 && <div className="absolute inset-0" style={{ background: `rgba(5,5,5,${dim})` }} />}
    </div>
  );
};
